/**
 * @generated SignedSource<<511755ebdfc8895ebe1b0d06b6a8a0ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutKlarnaPayment_buyer$data = {
  readonly addressBook: {
    readonly addressList: ReadonlyArray<{
      readonly city: string | null;
      readonly country: string | null;
      readonly firstName: string | null;
      readonly lastName: string | null;
      readonly line1: string | null;
      readonly line2: string | null;
      readonly phoneNumber: string | null;
      readonly serviceId: string | null;
      readonly state: string | null;
      readonly zipCode: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "CheckoutKlarnaPayment_buyer";
};
export type CheckoutKlarnaPayment_buyer$key = {
  readonly " $data"?: CheckoutKlarnaPayment_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutKlarnaPayment_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutKlarnaPayment_buyer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AddressBook",
      "kind": "LinkedField",
      "name": "addressBook",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "addressList",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "country",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "line1",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "line2",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "city",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "state",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "zipCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "phoneNumber",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "0e8c3448310b2f8e076949157d17066a";

export default node;
